import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  INSERT_BUTTON: `${cleanedFilename(__filename)}-insert-button`,
};
